import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import Fileupload from "../../components/Fileupload";
import { toast } from "react-toastify";
import {
  fileDelete,
  get_prev_files,
  getdownload,
  upload_file,
} from "../../api/api";
import Modal from "../../components/Modal";
import PreviousFiles from "../../components/PreviousFiles";

const QAtoDita = () => {
  const [selectedData, setSelectedData] = useState();
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState();
  const [prevfiles, setPrevFiles] = useState([]);
  const [downloadingFile, setDownloadingFile] = useState([]);
  const [emptyFiles, setEmptyFiles] = useState(0);
  const process = "wordq&a_to_dita";

  useEffect(() => {
    fetchprevfile(process);
  }, []);


  const handleSubmit = async () => {
    if (!selectedData) return;
    setIsSubmitted(true);
    try {
      const result = await upload_file(selectedData);
      if (result) {
        setIsSubmitted(false);
        toast.success("The file process completed.");
        fetchprevfile(process);
        setEmptyFiles(1);
        // console.log(result.data);
      }
    } catch (e) {
      toast.error(e || "An error Occurred");
      // console.log("error occured");
    } finally {
      setIsSubmitted(false);
    }
  };

  const fetchprevfile = async (process) => {
    try {
      let data = await get_prev_files(process);
      if (data) {
        setPrevFiles(data.data);
      } else {
        toast.error(data.error.message);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  console.log(selectedData);

  const handleDownload = async (fileid, process) => {
    setDownloadingFile((prev) => [...prev, fileid]);
    try {
      let data = await getdownload(fileid, process);
      if (data.data) {
        downloadreport(data.data.content, data.data.file_name);
      }
    } catch (e) {
      toast.error(e);
    } finally {
      setDownloadingFile((prev) => prev.filter((id) => id !== fileid));
    }
  };

  const handleFileDelete = async (fileid, filename) => {
    setShowModal(true);
    setFileToDelete({ fileid: fileid, filename: filename });
  };

  const downloadreport = (data, filename) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename);
    } catch (e) {
      console.log(e);
    }
  };

  const downloadfile = (url, filename) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`; // You can specify the name of the file here
      link.click();
      toast.success("File downloaded successfully");
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    } else {
      // alert("No File to Download");
      toast.info("No Files to Download");
    }
  };

  const confirmFileDelete = async () => {
    if (fileToDelete) {
      let response = await fileDelete(fileToDelete.fileid, process);
      if (response.data) {
        fetchprevfile(process);
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
      }
    }
  };

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      <div className="h-full w-full flex flex-col">
        <div className="p-8 flex flex-col gap-8 h-[100%]">
          <div className="text-left">
            <h1 className="text-24 font-semibold">Q&A to DITA Conversion</h1>
          </div>
          <Fileupload
           key={emptyFiles}
            // file={files}
            // setFiles={setFiles}
            setSelectedData={setSelectedData}
            category={"8"}
            emptyfile={emptyFiles}
          />
          <div className="w-full text-right flex gap-4 justify-end mt-10 mb-10">
            {/* <button
              className="py-2 px-5 border-[1px] rounded-lg border-commonborder text-btntext"
              onClick={() => confirmFileDelete()}
            >
              cancel
            </button> */}
            <button
              className="py-2 px-5 bg-highlighttext rounded-lg text-white"
              type="submit"
              onClick={() => handleSubmit()}
              disabled={isSubmitted}
            >
              {isSubmitted ? "Processing" : "Submit"}
            </button>
          </div>
          <PreviousFiles
            prevfiles={prevfiles}
            handleDownload={handleDownload}
            handleFileDelete={handleFileDelete}
            downloadingFile={downloadingFile}
            process={process}
          />
        </div>
      </div>
      {/* {showValidationModal && (
        <Modal
          title={"Alert"}
          body={
            "Do you wish to continue the processing in the Background and continue to Dashboard ?"
          }
          setShow={setShowValidationModal}
          setConfirm={runInBg}
          setSecondary={runInloading}
          cancelbtn={"Cancel"}
          confirmbtn={"Run in Background"}
          secondarybtn={"Continue to Loading screen"}
          // setbackground={setRunInBackground}
        />
      )} */}
      {showModal && (
        <div>
          <Modal
            title={"Alert"}
            body={`Do you wish to delete file ${fileToDelete?.filename} ?`}
            setShow={setShowModal}
            setConfirm={confirmFileDelete}
            confirmbtn={"Confirm"}
            cancelbtn={"Cancel"}
          />
        </div>
      )}
    </LoadingScreen>
  );
};

export default QAtoDita;